// Central business configuration for Smog Hut Modesto
export const BUSINESS = {
  name: "Smog Hut Modesto",
  legalName: "Smog Check Hut — Smog & Registration",
  shortName: "Modesto Smog Check",
  industry: "STAR Certified Smog Check Station",
  address: {
    street: "1455 Herndon Rd #3",
    city: "Modesto",
    state: "CA",
    zip: "95351",
    full: "1455 Herndon Rd #3, Modesto, CA 95351",
  },
  geo: { lat: 37.6103147, lng: -120.9751404 },
  phoneDisplay: "(209) 238-3877",
  phoneTel: "+12092383877",
  email: "smoghutmd@gmail.com",
  domain: "modestosmogcheck.com",
  primaryKeyword: "Smog Check Modesto",
  // Hours in 24h; null = closed
  hours: [
    { day: "Mon", open: "08:30", close: "17:00" },
    { day: "Tue", open: "08:30", close: "17:00" },
    { day: "Wed", open: "08:30", close: "17:00" },
    { day: "Thu", open: "08:30", close: "17:00" },
    { day: "Fri", open: "08:30", close: "17:00" },
    { day: "Sat", open: "09:00", close: "16:00" },
    { day: "Sun", open: null, close: null },
  ],
  hoursSummary: "Mon–Fri 8:30 AM–5 PM · Sat 9 AM–4 PM",
  // REAL Google profile — no fabricated numbers. Set rating/count when confirmed.
  google: {
    profileUrl: "https://g.page/smogCheckModestoCeres",
    reviewsUrl: "https://maps.app.goo.gl/aqPwvsqnFUSnCiCS8",
    rating: null, // e.g. 4.8 — leave null until confirmed real
    reviewCount: null, // e.g. 120
  },
  social: {
    yelp: "https://www.yelp.com/biz/smog-check-hut-modesto",
    youtube: "https://www.youtube.com/channel/UCp1n1KX-rXSlJvaXLPfp80Q",
  },
  cities: [
    { name: "Modesto", slug: "modesto", primary: true },
    { name: "Ceres", slug: "ceres" },
    { name: "Turlock", slug: "turlock" },
    { name: "Riverbank", slug: "riverbank" },
    { name: "Salida", slug: "salida" },
    { name: "Hughson", slug: "hughson" },
  ],
  images: {
    storefront: "https://static.prod-images.emergentagent.com/jobs/d545bb75-ba9c-4af4-b6db-78b7609fab62/images/fddd56cb8a157cfd80f432afa8c28ba14c852c14c98250f58a3462a8a675f956.jpeg",
    smogTest: "https://static.prod-images.emergentagent.com/jobs/d545bb75-ba9c-4af4-b6db-78b7609fab62/images/71df70df2433728f8b49b0ad7bed1d1097751f6936594f2cd2700eddc3e18cca.jpeg",
    equipment: "https://static.prod-images.emergentagent.com/jobs/d545bb75-ba9c-4af4-b6db-78b7609fab62/images/66bf5596d3f9e32c7eb01313c5610724a0e3347c3e01299365a228f9a5023dd8.jpeg",
  },
};

export const mapsSearchUrl = () =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${BUSINESS.name} ${BUSINESS.address.full}`
  )}`;

export const mapsDirUrl = () =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${BUSINESS.name}, ${BUSINESS.address.full}`
  )}`;

export const mapsEmbedUrl = () =>
  `https://www.google.com/maps?q=${encodeURIComponent(
    `${BUSINESS.name}, ${BUSINESS.address.full}`
  )}&output=embed`;

// Compute open/closed based on business hours (local America/Los_Angeles)
export function computeOpenNow() {
  const now = new Date();
  const la = new Date(now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  const dayIdx = la.getDay(); // 0 Sun .. 6 Sat
  const map = [6, 0, 1, 2, 3, 4, 5]; // JS Sun->our index
  const today = BUSINESS.hours[map[dayIdx]];
  if (!today || !today.open) return { open: false, today };
  const [oh, om] = today.open.split(":").map(Number);
  const [ch, cm] = today.close.split(":").map(Number);
  const mins = la.getHours() * 60 + la.getMinutes();
  const open = mins >= oh * 60 + om && mins < ch * 60 + cm;
  return { open, today };
}
